/* DillySocks — Judge.me: Bewertung schreiben im Slider (Sean 15.09.2026).

   Oeffnet auf Klick eines [data-ds-jm-write]-Elements (Kaufbox-Zusammen-
   fassung, Bewertungs-Sektion, Leerzustand) den gemeinsamen Drawer
   (window.dsDrawer aus ds-drawer.js — gleiche Ebene wie Quick-Add und
   Bundle-Picker, ueber Sticky-Leiste und Header). Das Formular-Markup
   kommt aus <template data-ds-jm-form-template> in
   sections/ds-judgeme-reviews.liquid (Texte aus den Locale-Dateien).

   Absenden: POST https://judge.me/api/v1/reviews (oeffentlicher Endpunkt
   von Judge.me, form-encoded, CORS offen) mit shop_domain, platform, id
   (Produkt-ID), url, name, email, rating, title, body. Judge.me prueft die
   Bewertung nach den App-Einstellungen (Freigabe) und pflegt danach die
   Metafelder, aus denen die Seite rendert. */
(function () {
  'use strict';
  if (window.dsJudgemeForm) return;
  window.dsJudgemeForm = true;

  var ENDPOINT = 'https://judge.me/api/v1/reviews';

  function init() {
    var root = document.querySelector('[data-ds-jm-reviews]');
    var tpl = root && root.querySelector('[data-ds-jm-form-template]');
    if (!root || !tpl) return;

    var drawer = null;

    function ensureDrawer() {
      if (drawer) return drawer;
      if (!window.dsDrawer) return null;
      drawer = window.dsDrawer.create({
        title: root.dataset.dsJmFormTitle || '',
        className: 'ds-jm-drawer',
        ariaLabel: root.dataset.dsJmFormTitle || ''
      });
      drawer.body.appendChild(tpl.content.cloneNode(true));
      wire(drawer.body);
      return drawer;
    }

    function wire(body) {
      var form = body.querySelector('[data-ds-jm-form]');
      var stars = body.querySelectorAll('[data-ds-jm-star]');
      var errorEl = body.querySelector('[data-ds-jm-error]');
      var success = body.querySelector('[data-ds-jm-success]');
      var submit = form.querySelector('[type="submit"]');
      var submitLabel = submit.textContent;

      function paint(n) {
        stars.forEach(function (s) {
          s.classList.toggle('is-on', Number(s.dataset.dsJmStar) <= n);
        });
      }
      function selected() {
        var r = form.querySelector('input[name="rating"]:checked');
        return r ? Number(r.value) : 0;
      }
      stars.forEach(function (s) {
        s.addEventListener('mouseenter', function () { paint(Number(s.dataset.dsJmStar)); });
        s.addEventListener('mouseleave', function () { paint(selected()); });
        var input = s.querySelector('input');
        if (input) input.addEventListener('change', function () { paint(selected()); });
      });

      function showError(msg) {
        errorEl.textContent = msg;
        errorEl.hidden = false;
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        errorEl.hidden = true;
        if (!selected()) { showError(root.dataset.dsJmRatingRequired || ''); return; }
        if (!form.checkValidity()) { form.reportValidity(); return; }

        var params = new URLSearchParams();
        params.set('shop_domain', root.dataset.dsJmShop || '');
        params.set('platform', 'shopify');
        params.set('id', root.dataset.dsJmProductId || '');
        params.set('url', root.dataset.dsJmProductUrl || '');
        params.set('name', form.elements.name.value.trim());
        params.set('email', form.elements.email.value.trim());
        params.set('rating', String(selected()));
        params.set('title', form.elements.title.value.trim());
        params.set('body', form.elements.body.value.trim());

        submit.disabled = true;
        submit.textContent = root.dataset.dsJmSending || submitLabel;

        fetch(ENDPOINT, { method: 'POST', body: params })
          .then(function (res) {
            return res.text().then(function (txt) {
              var data = null;
              try { data = JSON.parse(txt); } catch (err) { /* kein JSON */ }
              if (!res.ok) {
                throw new Error((data && data.message) || root.dataset.dsJmError || 'Error');
              }
              return data;
            });
          })
          .then(function () {
            form.hidden = true;
            success.hidden = false;
            success.querySelector('[data-ds-jm-close]').focus({ preventScroll: true });
          })
          .catch(function (err) {
            showError(err.message || root.dataset.dsJmError || 'Error');
          })
          .then(function () {
            submit.disabled = false;
            submit.textContent = submitLabel;
          });
      });

      var closeBtn = success.querySelector('[data-ds-jm-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { if (drawer) drawer.close(); });
    }

    function openWriteDrawer() {
      var d = ensureDrawer();
      if (!d) return false;
      d.open();
      var first = d.body.querySelector('[data-ds-jm-star] input');
      if (first && !d.body.querySelector('input[name="rating"]:checked')) first.focus({ preventScroll: true });
      return true;
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-ds-jm-write]');
      if (!trigger) return;
      if (!openWriteDrawer()) return; /* ohne Drawer-Basis bleibt der Anker-Sprung */
      e.preventDefault();
    });

    /* Newsletter-Deep-Link: #ds-jm-summary, oder ?open=ds-jm-summary wenn
       Klaviyo-Click-Tracking das Fragment vor dem Redirect abschneidet. */
    var fromHash = location.hash === '#ds-jm-summary';
    var fromQuery = false;
    try {
      fromQuery = new URLSearchParams(location.search).get('open') === 'ds-jm-summary';
    } catch (err) { /* URLSearchParams fehlt */ }
    if (fromHash || fromQuery) openWriteDrawer();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
